var map = {
	"./iq_test_default.json": [
		68238,
		8238
	],
	"./iq_test_default_eur.json": [
		28223,
		8223
	],
	"./iq_test_default_gbp.json": [
		29021,
		9021
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 69513;
module.exports = webpackAsyncContext;